/* import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import LanguageIcon from '@mui/icons-material/Language';
import { IconButton } from '@material-ui/core';
import { Icon } from '@iconify/react';
import Paper from '@mui/material/Paper'; */

/* export default function LanguageChoiceMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const changeLanguage = (ln: string) => {
    console.log(`Language Changed to ${ln}`);
    i18n.changeLanguage(ln);
    handleClose();
}

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton style={{ color: "white" }} id="basic-button"
        aria-controls={open ? 'demo-positioned-menu' : undefined}
        aria-haspopup="true" 
        aria-expanded={open ? 'true' : undefined} 
        onClick={handleClick}>
      <LanguageIcon />
    </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        anchorOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
      >
          <div>
        <MenuItem onClick={() => changeLanguage("en")}>
        <Icon icon="openmoji:flag-united-kingdom" />
            English</MenuItem>
        </div>
        <div>
        <MenuItem onClick={() => changeLanguage("it")}>
        <Icon icon="openmoji:flag-italy" spacing={1}/>
        Italiano</MenuItem>
        </div>
      </Menu>
     
    </div>
  );
}  */

import * as React from 'react';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import i18n from "../../i18n"; 
import i18next from 'i18next';
import { Icon } from '@iconify/react';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  select: {
    "&:before": {
      borderColor: "#FFFFFF",
    },
    "&:after": {
      borderColor: "white"
    }
  },
  icon: {
    fill: "white"
  },
}));

export default function LanguageSelect() {
  const [language, setLanguage] = React.useState(i18next.language);

  const handleChange = (event: SelectChangeEvent) => {
    setLanguage(event.target.value as string);
    changeLanguage(event.target.value as string);
  };

  const changeLanguage = (ln: string) => {
    localStorage.setItem("lng", ln);
    console.log(`Language Changed to ${ln}`);
    console.log(localStorage.getItem("lng"));
    i18n.changeLanguage(ln);
}

const classes = useStyles();
  return (
    <Box>
      <FormControl variant="standard" >
        <Select
          disableUnderline
          style={{ color: "white" }}
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={language}
          label={language}
          onChange={handleChange}
          inputProps={{
            classes: {
              icon: classes.icon
            }}}
        >
          <MenuItem value={"en"}> <Icon icon="openmoji:flag-united-kingdom" /> English</MenuItem>
          <MenuItem value={"it"}> <Icon icon="openmoji:flag-italy" spacing={1}/> Italiano</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

